module.exports = __webpack_public_path__ + "img/product_30.e4290ad.webp";